import React from 'react';
import EditorField from './_EditorField';

export default function DividerEditor({ section, dispatch }) {
  const cfg = section.section_config || {};
  const update = patch => dispatch({ type: 'UPDATE_SECTION_CONFIG', clientId: section._clientId, patch });

  return (
    <div>
      <EditorField label="Line Style">
        <select className="form-select form-select-sm" value={cfg.style || 'solid'} onChange={e => update({ style: e.target.value })}>
          <option value="solid">Solid</option>
          <option value="dashed">Dashed</option>
          <option value="dotted">Dotted</option>
          <option value="gradient">Gradient (Theme Color)</option>
          <option value="blank">Blank Spacer (no line)</option>
        </select>
      </EditorField>

      {cfg.style !== 'blank' && (
        <>
          <EditorField label="Color" hint="Leave empty to use the theme primary color">
            <input
              type="color"
              className="form-control form-control-sm form-control-color"
              value={cfg.color || '#e2e8f0'}
              onChange={e => update({ color: e.target.value })}
              style={{ width: 60, padding: 2 }}
            />
            <button
              type="button"
              className="btn btn-sm btn-link ms-2 p-0"
              style={{ fontSize: 11 }}
              onClick={() => update({ color: null })}
            >
              Use theme color
            </button>
          </EditorField>
          <EditorField label="Thickness (px)">
            <input
              type="number"
              className="form-control form-control-sm"
              min={1}
              max={20}
              value={cfg.thickness || 1}
              onChange={e => update({ thickness: parseInt(e.target.value) || 1 })}
            />
          </EditorField>
          <EditorField label="Width (%)">
            <input
              type="number"
              className="form-control form-control-sm"
              min={10}
              max={100}
              value={cfg.width || 80}
              onChange={e => update({ width: e.target.value })}
            />
          </EditorField>
        </>
      )}

      <EditorField label="Top Spacing">
        <select className="form-select form-select-sm" value={cfg.spacing_top || 'md'} onChange={e => update({ spacing_top: e.target.value })}>
          <option value="none">None</option>
          <option value="sm">Small</option>
          <option value="md">Medium</option>
          <option value="lg">Large</option>
          <option value="xl">Extra Large</option>
        </select>
      </EditorField>
      <EditorField label="Bottom Spacing">
        <select className="form-select form-select-sm" value={cfg.spacing_bottom || 'md'} onChange={e => update({ spacing_bottom: e.target.value })}>
          <option value="none">None</option>
          <option value="sm">Small</option>
          <option value="md">Medium</option>
          <option value="lg">Large</option>
          <option value="xl">Extra Large</option>
        </select>
      </EditorField>
    </div>
  );
}
